function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 13.568l4.278-4.273a1.01 1.01 0 011.427 0 1.006 1.006 0 010 1.424l-4.992 4.986a1.01 1.01 0 01-1.426 0l-4.992-4.986a1.006 1.006 0 010-1.424 1.01 1.01 0 011.427 0L12 13.568z"
});

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgChevronDown;